function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9339"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "undraw_add_files_re_v09g (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46070",
    d: "m272.811 99.309-4.055 1.046-49.962 12.884-4.055 1.046a7.678 7.678 0 0 0-5.511 9.342l17.585 68.19a7.678 7.678 0 0 0 9.342 5.511h.01l58.052-14.97h.011a7.678 7.678 0 0 0 5.511-9.342l-17.585-68.19a7.678 7.678 0 0 0-9.343-5.517z",
    transform: "translate(-208.984 -95.066)",
    style: {
      fill: "#d7dbdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46071",
    d: "m285.008 113.093-4.8 1.239-48.467 12.5-4.8 1.239a5.468 5.468 0 0 0-3.925 6.652l17.585 68.19a5.468 5.468 0 0 0 6.652 3.925h.01l58.052-14.97h.011a5.468 5.468 0 0 0 3.925-6.652l-17.585-68.19a5.468 5.468 0 0 0-6.658-3.933z",
    transform: "translate(-220.63 -106.712)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46072",
    d: "m426.863 239.3-29.363 7.574a1.277 1.277 0 1 1-.638-2.473l29.367-7.573a1.277 1.277 0 0 1 .638 2.473z",
    transform: "translate(-366.112 -210.839)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46073",
    d: "m438.719 257.237-34.469 8.889a1.277 1.277 0 1 1-.638-2.473l34.469-8.889a1.277 1.277 0 1 1 .638 2.473z",
    transform: "translate(-371.789 -225.916)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46074",
    d: "m457.132 356.675-29.367 7.573a1.277 1.277 0 0 1-.638-2.473l29.367-7.573a1.277 1.277 0 1 1 .638 2.473z",
    transform: "translate(-391.556 -309.507)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46075",
    d: "m468.987 374.611-34.469 8.889a1.277 1.277 0 0 1-.638-2.473l34.469-8.889a1.277 1.277 0 1 1 .638 2.473z",
    transform: "translate(-397.234 -324.584)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46076",
    d: "m487.4 474.048-29.367 7.573a1.277 1.277 0 0 1-.638-2.474l29.367-7.573a1.277 1.277 0 1 1 .638 2.473z",
    transform: "translate(-417 -408.175)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46077",
    d: "m499.255 491.984-34.469 8.889a1.277 1.277 0 0 1-.638-2.473l34.469-8.889a1.277 1.277 0 0 1 .638 2.473z",
    transform: "translate(-422.678 -423.252)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46078",
    d: "m303.018 293.653-10.393 2.68a.613.613 0 0 1-.746-.44l-2.386-9.251a.613.613 0 0 1 .44-.746l10.393-2.68a.613.613 0 0 1 .746.44l2.386 9.251a.613.613 0 0 1-.44.746z",
    transform: "translate(-276.647 -249.852)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46079",
    d: "m333.287 411.027-10.393 2.68a.613.613 0 0 1-.746-.44l-2.386-9.251a.613.613 0 0 1 .44-.746l10.393-2.68a.613.613 0 0 1 .746.44l2.386 9.251a.613.613 0 0 1-.44.746z",
    transform: "translate(-302.092 -348.52)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46080",
    d: "m363.555 528.4-10.393 2.68a.613.613 0 0 1-.746-.44l-2.386-9.251a.613.613 0 0 1 .44-.746l10.393-2.68a.613.613 0 0 1 .746.44l2.386 9.251a.613.613 0 0 1-.44.746z",
    transform: "translate(-327.536 -447.188)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46081",
    d: "M506.836 209.052h-59.973a7.678 7.678 0 0 0-7.67 7.67v70.421a7.678 7.678 0 0 0 7.67 7.67h59.973a7.678 7.678 0 0 0 7.67-7.67v-70.422a7.678 7.678 0 0 0-7.67-7.669z",
    transform: "translate(-402.505 -187.524)",
    style: {
      fill: "#d7dbdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46082",
    d: "M518.482 222.906h-59.973a5.468 5.468 0 0 0-5.462 5.462v70.421a5.468 5.468 0 0 0 5.462 5.462h59.973a5.468 5.468 0 0 0 5.462-5.462v-70.421a5.468 5.468 0 0 0-5.462-5.462z",
    transform: "translate(-414.151 -199.17)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46084",
    d: "M640.29 452.242h-30.328a1.277 1.277 0 1 1 0-2.554h30.328a1.277 1.277 0 0 1 0 2.554z",
    transform: "translate(-544.986 -389.81)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46085",
    d: "M645.558 479.289h-35.6a1.277 1.277 0 1 1 0-2.554h35.6a1.277 1.277 0 0 1 0 2.554z",
    transform: "translate(-544.986 -412.547)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46086",
    d: "M640.29 573.455h-30.328a1.277 1.277 0 0 1 0-2.554h30.328a1.277 1.277 0 0 1 0 2.554z",
    transform: "translate(-544.986 -491.706)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46087",
    d: "M645.558 600.5h-35.6a1.277 1.277 0 0 1 0-2.554h35.6a1.277 1.277 0 1 1 0 2.554z",
    transform: "translate(-544.986 -514.443)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46088",
    d: "M514.227 448.187h-10.733a.613.613 0 0 1-.612-.612v-9.554a.613.613 0 0 1 .612-.612h10.733a.613.613 0 0 1 .612.612v9.554a.613.613 0 0 1-.612.612z",
    transform: "translate(-456.044 -379.488)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46089",
    d: "M514.227 569.4h-10.733a.613.613 0 0 1-.612-.612v-9.554a.613.613 0 0 1 .612-.612h10.733a.613.613 0 0 1 .612.612v9.554a.613.613 0 0 1-.612.612z",
    transform: "translate(-456.044 -481.384)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46090",
    d: "M682.533 317.307h-22.36a1.277 1.277 0 1 1 0-2.554h22.36a1.277 1.277 0 0 1 0 2.554z",
    transform: "translate(-587.195 -276.379)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46091",
    d: "M687.8 344.355h-27.627a1.277 1.277 0 1 1 0-2.554H687.8a1.277 1.277 0 1 1 0 2.554z",
    transform: "translate(-587.195 -299.116)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46092",
    d: "M523.9 299.287h-20.617a.613.613 0 0 1-.612-.612v-16.088a.613.613 0 0 1 .612-.612H523.9a.613.613 0 0 1 .612.612v16.088a.613.613 0 0 1-.612.612z",
    transform: "translate(-455.866 -248.825)",
    style: {
      fill: "#9da7b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8677",
    style: {
      fill: "none"
    },
    d: "M0 0h112v112H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecords);
export default __webpack_public_path__ + "static/media/no-records.f3f2e7b4b829ce557867e865b9f53cf2.svg";
export { ForwardRef as ReactComponent };